<ifc-base-dialog [title]="data.title"
                 [actions]="data.actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <div class="body"
         [innerHTML]="data.body | safePureHtml"></div>
  </ng-template>
</ifc-base-dialog>
